export enum TipoEstadoServicio {
  OK,
  ERROR,
}
